export default "__VITE_ASSET__VGNvc$Py__"